import axios from "axios";
import { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { API_URL } from "../../Const";
import User from '../../User';
import './style.css';

function App() {

  const getState = (state: any, name: string): string =>
    (state as any)?.[name] ?? "";
  const history = useHistory();
  const email = getState(history.location.state, "email");
  const pass = getState(history.location.state, "pass");
  const name = getState(history.location.state, "name");
  const [posts, setPosts] = useState(0);

  useEffect(() => {
    axios.post(API_URL.USER_LOGIN, {
      "user_id": email,
      "password": pass,
      "company_id": name
    })
      .then(res => {
        let jsonObject = JSON.parse(res.data.data);
        localStorage.setItem("datalist", JSON.stringify(jsonObject));
        const username = jsonObject.user;
        setPosts(username)
      })
      .catch(error => {
        console.log('ログイン失敗')
        console.log(error)
        history.push({
          pathname: "/login", state:
          {
            err: '企業ID、メールアドレス、パスワードのいずれかが一致しません',
          }
        });
      });
  }, []);

  if (posts) {
    console.log('ログイン成功')
    User.login(email, pass);
    history.push({ pathname: "/Constructionlist" });
  }

  return (
    <div className='loginCheck'>
      <ReactLoading
        type="bars"
        color="#00bfff"
        height={'120px'}
        width={'120px'}
        className="mx-auto"
      />
      <h4 className='loginCheck'>ログイン中...</h4>
    </div>
  )
}

export default App